import {types} from './types';

const setGetListOrganizationAction = (payload) => {
    return {
        type: types.SET_LIST_ORGANIZATION,
        payload,
      }
}

export {
  setGetListOrganizationAction
}
